
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/car-finance/[slug]",
      function () {
        return require("private-next-pages/guides/car-finance/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/car-finance/[slug]"])
      });
    }
  